import EndContentBox from "../Components/EndContentBox"
import BackForwardButtonBox from "../Components/BackForwardButtonBox"

import { AnswersType } from "../Models/AnswersType"

import ImageDone from "../Assets/Images/Bildstöd2/färdigt.svg"

import { evaluationStageType } from "../Models/EvaluationStageType"
import { determineQuestionsArr } from "../Utilities/EvaluationStageVariables"
import { ActivePage } from "../Models/ActivePageType"

import { PolyglotContext } from "../../../polyglot/polyGlotContext"
import { useContext } from "react"

interface EvaluationEndProps {
    setPageToStart: () => void;
    setPageToQuestionX: (qNum: number) => void;
    setCollectedAnswers: React.Dispatch<React.SetStateAction<AnswersType>>;
    evaluationStage: evaluationStageType;
    collectedAnswers: AnswersType;
    setCollectedAnswersCopy: React.Dispatch<React.SetStateAction<AnswersType>>;
    collectedAnswersCopy: AnswersType;
    activePage: ActivePage;
}

const EvaluationEnd: React.FC<EvaluationEndProps> = ({
    setPageToStart,
    setPageToQuestionX,
    setCollectedAnswers,
    evaluationStage,
    collectedAnswers,
    setCollectedAnswersCopy,
    collectedAnswersCopy,
    activePage
}) => {
    const { polyglot } = useContext(PolyglotContext)

    //PROPS
    const backForwardButtonBoxProps = {
        makeVisible: false,
        activePage: activePage,
        setCollectedAnswers: setCollectedAnswers,
        evaluationStage: evaluationStage,
        collectedAnswers: collectedAnswers,
        collectedAnswersCopy: collectedAnswersCopy,
    };

    const endContentBoxProps = {
        imageA: ImageDone,
        imageAltA: polyglot.t("evaluationTool.evaluationEnd.imgAltA"),
        buttonText: polyglot.t("evaluationTool.evaluationEnd.btnTextFull"),
        buttonAction: () => { },
        evaluationStage: evaluationStage,
        setPageToStart: setPageToStart,
        collectedAnswers: collectedAnswers,
        setCollectedAnswersCopy: setCollectedAnswersCopy,
        setCollectedAnswers: setCollectedAnswers,
        collectedAnswersCopy: collectedAnswersCopy,
        setPageToQuestionX: () => setPageToQuestionX(1)
    };

    return (
        <>
            {collectedAnswersCopy && <BackForwardButtonBox {...backForwardButtonBoxProps} />}
            <EndContentBox {...endContentBoxProps} />
        </>
    )
}


export default EvaluationEnd
